export default "__VITE_ASSET__Bt3aV7pn__"